import { render, staticRenderFns } from "./AvailabilityHub.vue?vue&type=template&id=a10af148"
import script from "./AvailabilityHub.vue?vue&type=script&lang=js"
export * from "./AvailabilityHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports